module.exports = __webpack_public_path__ + "img/zoznam.bfbb9f77.png";